import React, { useState } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/WFOTForm.css";

const WFOTForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    place_of_work: "",
    life_certificate_url: null,
    iot_certificate_url: null,
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file && file.size > 10 * 1024 * 1024) {
      alert("File size exceeds 10MB. Please upload a smaller file.");
      e.target.value = "";
      return;
    }
    setFormData((prevData) => ({ ...prevData, [name]: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/createwfotform`;

      const fd = new FormData();
      fd.append("name", formData.name);
      fd.append("phone", formData.phone);
      fd.append("email", formData.email);
      fd.append("place_of_work", formData.place_of_work);
      fd.append("payment_status", "not paid"); // Set initial payment status as not paid
      
      // Add created_by if you have user authentication
      // fd.append("created_by", user.id);

      if (formData.life_certificate_url) {
        fd.append("life_certificate_url", formData.life_certificate_url);
      }
      if (formData.iot_certificate_url) {
        fd.append("iot_certificate_url", formData.iot_certificate_url);
      }

      const res = await axios.post(apiUrl, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        console.log("WFOT Form created:", res.data.data);
        // Redirect to payment page with form data
        navigate('/wfot-payment', {
          state: {
            wfotData: res.data.data
          }
        });
      }
    } catch (error) {
      console.error("Error creating WFOT form:", error);
      alert("Something went wrong! Please try again.");
    }
  };


  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container wfot-form-content-container">
          <section className="wfot-form-section">
            <Container className="container-wfot-form">
              <h2 className="text-center wfot-form-heading mb-4">WFOT Application Form</h2>

              <Form onSubmit={handleSubmit}>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Group controlId="formName">
                      <Form.Label className="form-label-wfot-form">Name</Form.Label>
                      <Form.Control
                        className="form-control-wfot-form"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter your name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formPhone">
                      <Form.Label className="form-label-wfot-form">Phone Number</Form.Label>
                      <Form.Control
                        className="form-control-wfot-form"
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="Enter your phone number"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Group controlId="formEmail">
                      <Form.Label className="form-label-wfot-form">Email Address</Form.Label>
                      <Form.Control
                        className="form-control-wfot-form"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter your email address"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formPlaceOfWork">
                      <Form.Label className="form-label-wfot-form">Place of Work</Form.Label>
                      <Form.Control
                        className="form-control-wfot-form"
                        type="text"
                        name="place_of_work"
                        value={formData.place_of_work}
                        onChange={handleInputChange}
                        placeholder="Enter your place of work"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* File Uploads */}
                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Group controlId="formLifeCertificate">
                      <Form.Label className="form-label-wfot-form">
                        AIOTA Life Membership Certificate
                      </Form.Label>
                      <Form.Control
                        className="file-input-wfot-form"
                        type="file"
                        name="life_certificate_url"
                        onChange={handleFileChange}
                        accept="application/pdf,image/*"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formIotCertificate">
                      <Form.Label className="form-label-wfot-form">
                        IOTR/ACOT Certificate
                      </Form.Label>
                      <Form.Control
                        className="file-input-wfot-form"
                        type="file"
                        name="iot_certificate_url"
                        onChange={handleFileChange}
                        accept="application/pdf,image/*"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Submit Button */}
                <Row className="d-flex justify-content-center mt-5">
                  <Button variant="primary" type="submit" size="lg" className="button-wfot-form">
                    Proceed to Payment
                  </Button>
                </Row>
              </Form>
            </Container>
          </section>
        </div>
      </div>

    </>
  );
};

export default WFOTForm;